import {createAction, props} from '@ngrx/store';
import {HttpErrorResponse} from '@angular/common/http';
import {Characteristics} from '@association/_common/models/characteristics.models';

export const LoadList = createAction(
    '[Characteristics] Load List',
    props<{ payload: string }>()
);

export const LoadListSuccess = createAction(
    '[Characteristics] Load List Success',
    props<{ payload: Characteristics }>()
);

export const LoadListFailure = createAction(
    '[Characteristics] Load List Failure',
    props<{ payload: HttpErrorResponse }>()
);

export const SetInitialState = createAction(
    '[Characteristics] Set Initial State'
);
